export default {
    START_LINE: "Начать со строки",
    CONTAINS_COLUMN_NAMES: "Мои данные содержат заголовки",
    DELIMITER: "Разделитель",
    PREVIEW: "Предварительный просмотр выбранных данных",
    OTHER_DELIMITER: "Другое",
    FIELD: "Поле",
    SYMBOL: "Символ"
};
